<template>
    <div class="home-week-dots">
        <div v-for="(day, i) in week" :key="i" class="wd" :class="displayState(day)">
            <span class="wd-day">{{ dayLetter(day) }}</span>
            <span class="wd-icon">{{ stateIcon(displayState(day)) }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "HomeWeekDots",
    props: {
        week: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        isToday(day) {
            return day.dateFull === this.$moment().format('YYYY-MM-DD')
        },
        displayState(day) {
            if (day.status === 'done' || day.status === 'competence') return 'done'
            if (this.isToday(day)) return 'today'
            if (day.status === 'partial') return 'partial'
            if (day.status === 'not_realize') return 'missed'
            if (day.status === 'to_realize') return 'scheduled'
            return 'empty'
        },
        dayLetter(day) {
            const vm = this
            const m = vm.$moment(day.dateFull, 'YYYY-MM-DD')
            if (vm.$i18n.locale !== 'en' && m.day() === 3) return 'X'
            return m.format('dd').charAt(0).toUpperCase()
        },
        stateIcon(state) {
            const map = { done: '✓', missed: '✗', partial: '◐', today: '·', scheduled: '·', empty: '–' }
            return map[state] || '–'
        },
    },
}
</script>

<style scoped>
.home-week-dots {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.wd {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1px;
    font-size: 10px;
    font-weight: 700;
    flex-shrink: 0;
}

.wd-day {
    font-size: 8px;
    font-weight: 600;
    text-transform: uppercase;
    opacity: 0.7;
}

.wd-icon {
    font-size: 12px;
    line-height: 1;
}

.wd.done {
    background: rgba(0, 153, 102, 0.15);
    border: 1.5px solid rgba(0, 153, 102, 0.5);
    color: var(--v-success-base);
}

.wd.missed {
    background: rgba(232, 92, 92, 0.12);
    border: 1.5px solid rgba(232, 92, 92, 0.4);
    color: var(--v-error-base);
}

.wd.partial {
    background: rgba(107, 114, 128, 0.14);
    border: 1.5px solid rgba(107, 114, 128, 0.5);
    color: var(--v-txtSecondary-base);
}

.wd.today {
    background: rgba(51, 153, 153, 0.12);
    border: 1.5px solid var(--v-accent-base);
    color: var(--v-accent-base);
    font-weight: 800;
}

.wd.scheduled {
    background: rgba(51, 153, 153, 0.06);
    border: 1.5px dashed rgba(51, 153, 153, 0.45);
    color: var(--v-accent-base);
}

.wd.empty {
    background: var(--v-surface2-base);
    border: 1.5px solid var(--v-outline-base);
    color: var(--v-txtMuted-base);
    opacity: 0.5;
}

@media (max-width: 599px) {
    .wd {
        width: 26px;
        height: 26px;
    }
}
</style>
